export const Loader = () => {
  return (
    <span className="loader"></span>
  )
}